import { array } from '@mojotech/json-type-validation'

import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { ModelAnswerRepository } from '@/domain/repositories/modelAnswer/modelAnswerRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { modelAnswerDecoder } from '@/infrastructure/decoders/modelAnswer/modelAnswerDecoder'

export class ModelAnswerRepositoryImpl implements ModelAnswerRepository {
  constructor(private clients: ApiClients) {}

  async getSolutionWithRating(
    problemId: string,
    programLanguage: ProgramLanguageType,
    pageIndex: number
  ): Promise<ModelAnswer[]> {
    const size = 20
    const path = `solutions/problems/${problemId}/lang/${programLanguage}/rating?page=${pageIndex}&size=${size}`
    return this.clients.aojClient.fetchAndDecode(array(modelAnswerDecoder), path)
  }
}
